// 参考文档 https://github.com/Gozala/events
import EventEmitter from 'events';

export default new EventEmitter();
